import { render, staticRenderFns } from "./RegisterFromOrderDialog.vue?vue&type=template&id=88e85870&scoped=true&"
import script from "./RegisterFromOrderDialog.vue?vue&type=script&lang=js&"
export * from "./RegisterFromOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFromOrderDialog.vue?vue&type=style&index=0&id=88e85870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e85870",
  null
  
)

export default component.exports